import type { ServiceAbilityRequest } from '../../../core/models/service-ability';

export interface MapServiceAbilityRequestOptions {
  shipDate: string;
}

/**
 * Formats a date as YYYY-MM-DD for POST /service-ability/check.
 */
export function formatServiceAbilityShipDate(date: Date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

/**
 * Builds the token-only POST /service-ability/check body from the AVS attestation.
 * Origin/destination/returnTo are not sent — those facts are attested inside the JWT.
 */
export function mapAddressValidationTokenToServiceAbilityRequest(
  addressValidationToken: string,
  options?: MapServiceAbilityRequestOptions,
): ServiceAbilityRequest {
  return {
    shipDate: options?.shipDate ?? formatServiceAbilityShipDate(),
    addressValidationToken,
  };
}
